import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { ConfirmButton } from 'components/common';

const GroupCoursesRemove = connect(state => ({
  messages: state.messages,
  pageState: state.pageState
}))(class extends Component {
  removeCourse = async () => {
    const { courseId, pageState: { group }, updateCourses } = this.props;

    await api.delete(`/admin/groups/${group.id}/courses/${courseId}`);
    await updateCourses();
    return true;
  }

  render() {
    const { messages } = this.props;

    return (
      <ConfirmButton
        actionText={messages.commonRemove}
        buttonIcon="trash-alt"
        buttonIsDropdown={true}
        buttonText={messages.groupsCoursesRemove}
        category="danger"
        confirmText={messages.groupsCoursesRemoveConfirm}
        confirmTitle={messages.groupsCoursesRemove}
        onConfirm={this.removeCourse}
        successMessage={messages.groupsCoursesRemoveSuccess}
      />
    );
  }
});

export default GroupCoursesRemove;
